<ng-container *ngIf="!loading">
    <p-dropdown inputId="scCityId" [options]="list" [(ngModel)]="selectedItem" optionLabel="name" [filter]="true"
        filterBy="name" [showClear]="true" [placeholder]="placeHolderLanguage" (onChange)="feedback()"
        [style]="{'width':'100%', 'font-size':'45px'}" [disabled]="disabled"></p-dropdown>
</ng-container>
<ng-container *ngIf="loading">
    <div class="col-12">
        Carregando...
    </div>
</ng-container>